import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import TitleBar from '../../../../../../components/LazyWidgets/TitleBar';
import Button from '../../../../../../components/LazyWidgets/Button';
import { createStyles } from './styles';
import { useZIndexFocusDetection } from '../../../../../hooks/useZIndexFocusDetection';

function TransitionSlide(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
}
const Transition = React.forwardRef(TransitionSlide);

export default function MLDialog({ title, isOpen, handleClose, children }) {
  const classes = createStyles();
  const {
    modalContainerRef,
    shouldDisableEnforceFocus,
  } = useZIndexFocusDetection(isOpen);

  return (
    <Dialog
      fullScreen
      open={isOpen}
      onClose={handleClose}
      TransitionComponent={Transition}
      disableEnforceFocus={shouldDisableEnforceFocus}
      ref={modalContainerRef}
    >
      <TitleBar title={title} className={classes.titleBar}>
        <Button
          onClick={handleClose}
          theme="secondary"
          style={{ marginLeft: 'auto' }}
        >
          Close
        </Button>
      </TitleBar>
      <DialogContent className={classes.dialogContent}>
        {children}
      </DialogContent>
    </Dialog>
  );
}

MLDialog.propTypes = {
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.any,
};
